import React from 'react'
import { ContentBlock } from 'components/ContentBlock'
import CashRegistersTree from 'components/CashRegisterTree'

const CashRegisters = ({ data, mutations: { updateItem } }) => (
	<ContentBlock>
		<CashRegistersTree
			activeNodesArr={data.cashRegisterId}
			onChange={cashRegisterId => updateItem({ cashRegisterId })}
			withContext
		/>
	</ContentBlock>
)

export default CashRegisters
